import React from 'react';

export function UnifiedProgress({ 
  type, 
  status, 
  progress = 0, 
  error = null,
  onCancel,
  onRetry 
}) {
  const getStatusConfig = () => {
    const configs = {
      pending: { color: '#6b7280', icon: '⏳', label: 'Queued' },
      processing: { color: '#3b82f6', icon: '⚡', label: 'Processing' },
      completed: { color: '#10b981', icon: '✅', label: 'Completed' },
      failed: { color: '#ef4444', icon: '❌', label: 'Failed' }
    };
    return configs[status] || configs.pending;
  };

  const config = getStatusConfig();
  
  return (
    <div style={{
      background: '#111827',
      border: `1px solid ${config.color}`,
      borderRadius: 8,
      padding: 12,
      marginBottom: 8
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 16 }}>{config.icon}</span>
        <div style={{ flex: 1 }}>
          <div style={{ color: '#f9fafb', fontSize: 14, fontWeight: 600 }}>
            {type.charAt(0).toUpperCase() + type.slice(1)} Generation
          </div>
          <div style={{ color: config.color, fontSize: 12 }}>
            {config.label}
            {status === 'processing' && progress > 0 && ` - ${progress}%`}
          </div>
        </div>
        
        {status === 'processing' && (
          <button
            onClick={onCancel}
            style={{
              background: '#ef4444',
              color: '#fff',
              border: 0,
              borderRadius: 4,
              padding: '4px 8px',
              fontSize: 12,
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
        )}
        
        {status === 'failed' && (
          <button
            onClick={onRetry}
            style={{
              background: '#ff5a1f',
              color: '#fff',
              border: 0,
              borderRadius: 4,
              padding: '4px 8px',
              fontSize: 12,
              cursor: 'pointer'
            }}
          >
            Retry
          </button>
        )}
      </div>
      
      {status === 'processing' && progress > 0 && (
        <div style={{ marginTop: 8 }}>
          <div style={{
            background: '#1f2937',
            borderRadius: 4,
            height: 4,
            overflow: 'hidden'
          }}>
            <div style={{
              background: config.color,
              width: `${progress}%`,
              height: '100%',
              transition: 'width 0.3s ease'
            }} />
          </div>
        </div>
      )}
      
      {error && (
        <div style={{
          color: '#ef4444',
          fontSize: 12,
          marginTop: 4,
          padding: '4px',
          background: '#1f2937',
          borderRadius: 4
        }}>
          {error}
        </div>
      )}
    </div>
  );
}
